import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d2512634")

_pushScopeId("data-v-d2512634")
const _hoisted_1 = { class: "close-tip df-middle px-16" }
const _hoisted_2 = { class: "flex-1 f-sm ml-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Pic, {
      src: "closed",
      width: "32",
      height: "32"
    }),
    _createVNode("div", _hoisted_2, [
      (_ctx.isCC)
        ? (_openBlock(), _createBlock(_component_t, {
            key: 0,
            as: "p",
            path: "symbol_26",
            args: {close: _ctx.times.join('-')}
          }, {
            default: _withId(() => [
              _createTextVNode(" Closing Time: " + _toDisplayString(_ctx.times[0]) + " - " + _toDisplayString(_ctx.times[1]) + " Open on weekends. ", 1)
            ]),
            _: 1
          }, 8, ["args"]))
        : (_openBlock(), _createBlock(_component_t, {
            key: 1,
            as: "p",
            path: "symbol_26",
            args: {close: _ctx.times.join('-')}
          }, {
            default: _withId(() => [
              _createTextVNode(" Closing Time: " + _toDisplayString(_ctx.times[0]) + " - " + _toDisplayString(_ctx.times[1]) + " Closed all day on weekends. ", 1)
            ]),
            _: 1
          }, 8, ["args"]))
    ])
  ]))
})